import React from "react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

const messageData = {
  title: "Message from the CEO & Founder",
  subTitle: "I warmly welcome you to the world of Celbion Healthcare.",
  bannerBg: "/images/about/banner_bg.jpg",
  bannerImg: "/images/doctors/banner_img.png",
  paragraphs: [
    "At Celbion Healthcare, we believe that trust is the most valuable currency in medicine.",
    "As clinicians, you face increasing complexity - patients living longer with chronic neurological and psychiatric conditions, rising expectations, and constant information overload. In such an environment, what truly helps is clarity, scientific integrity, and dependable therapeutic choices.",
    "Celbion was created with a simple but powerful vision: to support doctors, not influence them.",
    "<b>Every Celbion formulation is developed after asking three fundamental questions:</b> </br> 1. Does this combination make scientific sense? </br> 2. Is it safe for long-term use? </br> 3. Will it genuinely improve patient outcomes and adherence? ",
    "Beyond medicines, we are deeply committed to supporting clinicians through education, scientific dialogue, patient awareness, and responsible engagement. We see ourselves as long-term partners in your clinical journey.",
    "On behalf of team Celbion, I thank you ffor your trust and collaboration. ",
    "As clinicians, you face increasing complexity - patients living longer with chronic neurological and psychiatric conditions, rising expectations, and constant information overload. In such an environment, what truly helps is clarity, scientific integrity, and dependable therapeutic choices.",
  ],
  signature: ["- CEO & Founder", "Celbion Healthcare"],
};

export default function MessageFromCEO() {
  pageTitle("Message From CEO");
  return (
    <>
      <BannerSectionStyle3
        bgUrl={messageData.bannerBg}
        imgUrl={messageData.bannerImg}
        title={messageData.title}
        subTitle={messageData.subTitle}
      />

      <Section topMd={80} topLg={80} topXl={80}>
        <div className="container">
          <div className="ceoWrapper">
            {/* LEFT SIDE */}
            <div className="ceoLeft">
              <h2>
                CEO / FOUNDER <br /> MESSAGE
              </h2>

              <p className="ceoSub">
                Message from <br /> the CEO & Founder
              </p>
              {/* 
              <div className="ceoPerson">
                <img src="/images/messsagefromCEO.svg" alt="CEO" />
              </div> */}
            </div>

            {/* RIGHT SIDE */}
            <div className="ceoRight">
              {/* Quote Icon */}
              <div className="quoteIcon"></div>

              <div className="ceoCard2">
                <div className="ceoCard">
                  {messageData.paragraphs.map((p, i) => (
                    <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
                  ))}
                </div>
              </div>
              <div className="ceoSign">
                {messageData.signature.map((s, i) => (
                  <p key={i}>{s}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
